module.exports = __webpack_public_path__ + "static/media/circle_filled_red.f370a96e.svg";